import packageJson from '../../package.json';

type ReleaseStageType = 'dev' | 'staging' | 'qa' | 'prd';

export default function getEnv(env: string) {
  return window.env[env];
}

const APP_VERSION = packageJson.version;
const RELEASE_STAGE = process.env.REACT_APP_RELEASE_STAGE as ReleaseStageType;
const PUBLIC_URL = process.env.PUBLIC_URL;
const SPLIT_IO_KEY = process.env.REACT_APP_SPLIT_IO_KEY as string;

const CONVERSATION_APP_ID = getEnv('CONVERSATION_APP_ID') as string;

export { APP_VERSION, RELEASE_STAGE, PUBLIC_URL, SPLIT_IO_KEY, CONVERSATION_APP_ID };
